import { Icon } from "@wisr/react-ui";
import React from "react";

import removeButtonstyle from "./remove-button.scss";

interface RemoveButtonProps {
  onClick: () => void;
}
export const RemoveButton: React.FunctionComponent<RemoveButtonProps> = ({
  onClick,
}) => (
  <>
    <style jsx>{removeButtonstyle}</style>
    <section className="remove-button" onClick={onClick}>
      <Icon name="action-delete" size="sm" legacy={true}></Icon> Remove
    </section>
  </>
);
